import { isPrivilegedRole } from "@adpilot/shared";

interface ApprovalShopMembership {
  shopId: string;
  role: "owner" | "admin" | "member";
  permissions: string[];
}

export function canAccessApprovalQueue(
  shops: readonly ApprovalShopMembership[],
  currentShopId: string | null,
): boolean {
  const membership = shops.find(({ shopId }) => shopId === currentShopId);
  return isPrivilegedRole(membership?.role) || membership?.permissions.includes("approve") === true;
}
